import React from 'react';
import PropTypes from 'prop-types';
import SEO from '../../components/seo';
import Hero from '../../components/hero';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import ContactArea from '../contact-area';
import Benefits from '../Benefits';
import UnitList from '../UnitList';
import TeachersList from '../../components/TeachersList';
import { device } from '../../theme';
import AccordionInfo from '../../components/AccordionInfo';

const PreparationCoursePage = ({ title, description, location, data }) => {
  const { hero, faq, teachers, benefits } = data;

  const backgroundImage = [
    hero.mobileBackgroundImage.childImageSharp.fluid,
    {
      ...hero.backgroundImage.childImageSharp.fluid,
      media: device.smallOnly,
    },
  ];

  return (
    <>
      <SEO title={title} description={description} location={location} image={hero.image.childImageSharp.fluid.src} />
      <Header />
      <Hero
        title={hero.title}
        subtitle={hero.subtitle}
        description={hero.description}
        action={hero.action}
        image={hero.image.childImageSharp.fluid}
        backgroundImage={backgroundImage}
        dark
      />
      <AccordionInfo
        title={faq.title}
        subtitle={faq.subtitle}
        items={faq.items}
        videoLink={faq.videoLink}
        videoImage={faq.videoImage}
        images={{
          first: faq.image1,
          second: faq.image2,
          third: faq.image3,
          fourth: faq.image4,
        }}
      />
      <Benefits itemsFilter={benefits.items} title={benefits.title} primaryAction={benefits.primaryAction} />
      <TeachersList itemsFilter={teachers} />
      <UnitList />
      <ContactArea />
      <Footer />
    </>
  );
};

PreparationCoursePage.propTypes = {
  location: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  data: PropTypes.shape({
    hero: PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      description: PropTypes.string,
      action: PropTypes.shape({
        label: PropTypes.string,
        link: PropTypes.string,
      }),
      image: PropTypes.object,
      backgroundImage: PropTypes.object,
      mobileBackgroundImage: PropTypes.object,
    }),
    faq: PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          content: PropTypes.string,
        })
      ),
      videoLink: PropTypes.string,
      videoImage: PropTypes.object,
      image1: PropTypes.object,
      image2: PropTypes.object,
      image3: PropTypes.object,
      image4: PropTypes.object,
    }),
    teachers: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
        image: PropTypes.object,
      })
    ),
    benefits: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default PreparationCoursePage;
